import React from "react";
import HintIconToolTip from "./HintIconToolTip";

function TooltipComment({ isTreatment = false, isDisplay = true }) {
  if (!isDisplay) return null;
  return (
    <HintIconToolTip placement="right">
      <div>
        <p className>
          以下入力欄にドラッグ＆ドロップでファイルを添付可能です。
        </p>
        <h4>■ファイル条件</h4>
        <ul>
          <li className="ml-3">
            条件1)　
            {isTreatment
              ? "ファイル数上限：最大５ファイル/処置コメント1つ"
              : "ファイル数上限：最大５ファイル/点検コメント1つ"}
          </li>
          <li className="ml-3">条件2)　ファイル容量上限：合計15MB/5ファイル</li>
          <li className="ml-3">条件3)　ファイル形式：JPG,GIF,PNG,PDFのみ</li>
          <li className="ml-3">
            例）　3MBのファイルの場合、5ファイルまで添付可能 <br></br>（
            ファイル容量上限　15MB　＞　3MB × 5ファイル ）
          </li>
        </ul>
      </div>
    </HintIconToolTip>
  );
}

export default TooltipComment;
